export default __webpack_public_path__ + "static/media/image7.29e39227.png";